import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import SingleAccordion from 'components/accordions/SingleAccordion';
import TextSection from 'components/contentBlocks/TextSection';
import { above } from 'utils/mediaqueries';
import colors from 'config/theme/colors';
import styled from 'libs/styled';
import { textContentProp } from 'utils/proptypes/modules/textProps';

const Wrapper = styled('div')`
    border-top: 1px solid ${colors.grey4};
    border-bottom: 1px solid ${colors.grey4};
`;

const Col = styled('div')`
    padding-bottom: 24px;

    ${above.md} {
        padding-top: 16px;
        padding-bottom: 40px;
    }
`;

const AccordionSection = ({ items = [] }) => {
    const [activeAccordion, setActiveAccordion] = useState([]);

    // Open accordion if anchorTag is present in window.location
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const id = hash.replace('#', '');
            const anchorTags = items?.reduce((tags, item, index) => {
                if (item.anchorTag) {
                    tags[item.anchorTag] = index;
                }
                return tags;
            }, {});

            if (Object.keys(anchorTags).includes(id)) {
                setActiveAccordion([...activeAccordion, anchorTags[id]]);
            }
        }
    }, [items]);

    return items?.length > 0 ? (
        <Wrapper>
            {items.map(({ label, anchorTag, data }, index) => (
                <SingleAccordion
                    maxWithContent
                    anchorTag={anchorTag}
                    animationDuration={200}
                    borderBottom={items.length - 1 !== index}
                    colorText={colors.black}
                    headerPX="0"
                    headerPY={['16px', null, '24px']}
                    headingSize="md"
                    isActive={activeAccordion.includes(index)}
                    key={label}
                    text={label}
                    timingFunction="ease"
                    handleClick={() =>
                        setActiveAccordion(
                            activeAccordion.includes(index)
                                ? activeAccordion.filter(activeIndex => activeIndex !== index)
                                : [...activeAccordion, index]
                        )
                    }
                >
                    <Col>
                        <TextSection textSections={data} />
                    </Col>
                </SingleAccordion>
            ))}
        </Wrapper>
    ) : null;
};

AccordionSection.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            anchorTag: PropTypes.string,
            data: textContentProp,
        })
    ),
};

export default AccordionSection;
